export const TTL_MS = 10 * 60 * 1000; // 10 min
export const HEALTH_INDICATOR_TTL_MS = 60 * 60 * 1000; // 1 hour
